import { css } from "@emotion/css";
export default css({
    "&&.ant-modal .ant-modal-content .ant-modal-body": {
        padding: "48px 70px",
        "& .ant-card": {
            boxShadow: "0px 0px 40px rgba(30, 30, 30, 0.1)"
        }
    }
});
